import { useState } from "react";
import lock from "../../assets/img/Lock.svg";
import eye from "../../assets/img/eye-off.svg";
import { useTranslation } from "react-i18next";


export default function Password() {
  const { t } = useTranslation();
  
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
    return false;
  };

  return (
    <div className="password">
      <img src={lock} alt=""/>
      <input name="password" type={passwordShown ? "text" : "password"} placeholder={ t("Password") } />
      <a onClick={togglePassword} className={passwordShown ? "hide-pass" : "show-pass"}><img src={eye} alt=""/></a>
    </div>
  );
}